





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({ components: {} })
export default class message_input extends Vue {
  @Prop({ type: Boolean, default: false }) public isLoading!: boolean;
  @Prop({ type: String, default: "" }) public draft!: string;

  public localDraft: string = "";

  mounted() {
    this.localDraft = this.draft || "";
  }

  @Watch("draft") onDraftChanged(val: string) {
    this.localDraft = val || "";
  }

  get hasText(): boolean {
    return this.localDraft && this.localDraft.trim().length > 0 ? true : false;
  }

  private emitSend(): void {
    if (!this.isLoading && this.hasText) {
      this.$emit("send", this.localDraft);
      this.localDraft = "";
    }
  }
}
